import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { GenericSearchComponent } from './generic-search.component';
import { GenericSelectorModule } from '../generic-selector/generic-selector.module';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from "@progress/kendo-angular-inputs";
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';

@NgModule({
    imports: [
        CommonModule,
        DatePickerModule,
        ButtonModule,
        GenericSelectorModule,
        InputsModule,
        ComboBoxModule
    ],
    declarations: [
        GenericSearchComponent
    ],
    exports: [
        GenericSearchComponent
    ]

})
export class GenericSearchModule {
    static forRoot(): ModuleWithProviders<GenericSearchModule> {
    return {
        ngModule: GenericSearchModule,
        providers: [GlobalsService, DQOIService]
    };
}
}
